// in localStorage data

import * as actionTypes from '../actionTypes';

const state = {
  userLanguage: '',
  isShowPriorSettingBlock: true,
  isOpenedSmsEditInstructionPanel: true,
  listNoticeShow: ['1'],
  isHiddenRightBottomHint: false,
  isHiddenEmailTemplateHint: false,
  isHiddenHealthFormHint: false,
  isHiddenTutorialTabHint: false, // 隱藏步驟流程 Tab
  isEmailFormatChecked: true,
  isCellPhoneFormatChecked: true,
  isVisitFirstTime: true, // 第一次造訪平台
  isNotBadgeLabelMachineRentInformationShown: false, // 不顯示標籤機租用資訊 toast
};

function envSettingReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.SET_USER_LANGUAGE:
      return {
        ...globalState,
        userLanguage: action.data,
      };
    case actionTypes.SET_IS_SHOW_PRIOR_SETTING_BLOCK:
      return {
        ...globalState,
        isShowPriorSettingBlock: !globalState.isShowPriorSettingBlock,
      };
    case actionTypes.SET_LIST_NOTICE_SHOW:
      return {
        ...globalState,
        listNoticeShow: action.key,
      };
    case actionTypes.SET_IS_OPENED_SMS_EDIT_INSTRUCTION_PANEL:
      return {
        ...globalState,
        isOpenedSmsEditInstructionPanel: action.isOpened,
      };
    case actionTypes.SET_IS_HIDDEN_RIGHT_BOTTOM_HINT:
      return {
        ...globalState,
        isHiddenRightBottomHint: action.isHidden,
      };
    case actionTypes.SET_IS_HIDDEN_EMAIL_TEMPLATE_HINT:
      return {
        ...globalState,
        isHiddenEmailTemplateHint: action.isHidden,
      };
    case actionTypes.SET_IS_HIDDEN_HEALTH_FORM_HINT:
      return {
        ...globalState,
        isHiddenHealthFormHint: action.isHidden,
      };
    case actionTypes.SET_IS_HIDDEN_TUTORIAL_TAB_HINT:
      return {
        ...globalState,
        isHiddenTutorialTabHint: action.isHidden,
      };
    case actionTypes.SET_IS_EMAIL_FORMAT_CHECKED:
      return {
        ...globalState,
        isEmailFormatChecked: action.isChecked,
      };
    case actionTypes.SET_IS_CELL_PHONE_FORMAT_CHECKED:
      return {
        ...globalState,
        isCellPhoneFormatChecked: action.isChecked,
      };
    case actionTypes.SET_IS_VISIT_FIRST_TIME:
      return {
        ...globalState,
        isVisitFirstTime: action.isFirstTime,
      };
    case actionTypes.SET_IS_NOT_BADGE_LABEL_MACHINE_RENT_INFORMATION_SHOWN:
      return {
        ...globalState,
        isNotBadgeLabelMachineRentInformationShown: action.isChecked,
      };
    default:
      return globalState;
  }
}

export { envSettingReducer as default };
